const debugLogger = (message, value = '') => {
    if (process.env !== 'prod') {
        console.log(message, value);
    }
};
export default debugLogger;